/* src/app/shared/components/flow-drop-down/flow-drop-down.component.scss */
.drop-down-anchor.overlayed {
  position: static;
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
}
.flow-drop-down {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-radius: 12px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  box-shadow: 0 1px 5px -4px rgba(0, 0, 0, 0.5), 0 4px 8px 0 rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition:
    max-height 0.2s ease-in-out,
    padding-top 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;
  padding-top: 0;
  border-width: 0;
  box-shadow: none;
}
.flow-drop-down.open {
  padding-top: 8px;
  border-width: 1px;
  box-shadow: 0 1px 5px -4px rgba(0, 0, 0, 0.5), 0 4px 8px 0 rgba(0, 0, 0, 0.05);
}
.flow-drop-down.open.no-footer {
  padding-bottom: 8px;
}
.drop-down-header {
  flex-shrink: 0;
  padding: 8px;
  padding-top: 0px;
  border-bottom: 1px solid #e4e4e7;
  margin-bottom: 8px;
}
.drop-down-list {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: hidden;
  margin-top: -8px;
  margin-bottom: -8px;
  padding-top: 8px;
  padding-bottom: 8px;
  scrollbar-width: thin;
  scrollbar-color: #71717a #e4e4e7;
  scrollbar-color: #71717a transparent;
}
.drop-down-list::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}
.drop-down-list::-webkit-scrollbar-track {
  background: #e4e4e7;
  border-radius: 100px;
}
.drop-down-list::-webkit-scrollbar-thumb {
  background: #71717a;
  border-radius: 100px;
  border: 2px solid transparent;
  background-clip: padding-box;
}
.drop-down-list::-webkit-scrollbar-track {
  background: transparent;
}
.flow-drop-down.scrollable .drop-down-list {
  overflow-y: auto;
}
.drop-down-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 24px;
  text-align: center;
}
.drop-down-empty .drop-down-empty__subtitle {
  color: #71717a;
}
.drop-down-divider {
  flex-shrink: 0;
  padding: 4px 12px;
  border-bottom: 1px solid #e4e4e7;
  margin-top: 4px;
  margin-bottom: 4px;
}
.drop-down-divider .drop-down-divider__title {
  color: #71717a;
}
.drop-down-divider.first-row {
  margin-top: 0;
}
.drop-down-divider.line-only {
  padding: 0;
}
.drop-down-custom-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  gap: 8px;
  width: calc(100% - 16px);
  margin: 0 8px;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.1s ease-in-out;
}
.drop-down-custom-item:hover {
  background-color: #f4f4f5;
}
.drop-down-custom-item .drop-down-custom-item__title {
  flex: 1 1 auto;
}
.drop-down-custom-item .drop-down-custom-item__delete {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
}
.drop-down-custom-item .drop-down-custom-item__delete img {
  cursor: pointer;
  height: 30px;
  width: 30px;
  padding: 6px;
  border-radius: 8px;
  border: 1px solid transparent;
}
.drop-down-custom-item .drop-down-custom-item__delete img:hover {
  border: 1px solid #e4e4e7;
  background: #ffffff;
}
.drop-down-add {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  padding-bottom: 0px;
  margin-top: 8px;
  border-top: 1px solid #e4e4e7;
  background: #ffffff;
}
.drop-down-add .drop-down-add__input {
  flex: 1 1 auto;
  min-width: 0;
}
.drop-down-add + .drop-down-footer {
  border-top: none;
}
.drop-down-footer {
  margin-top: 8px;
  flex-shrink: 0;
  padding: 8px;
  border-top: 1px solid #e4e4e7;
  display: flex;
  align-items: center;
  gap: 8px;
}
.drop-down-footer .drop-down-footer__add {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #18181b;
  cursor: pointer;
}
.drop-down-footer .drop-down-footer__add:hover {
  background: #fafafa;
}
.drop-down-footer .drop-down-footer__add .drop-down-footer__add-icon {
  width: 16px;
  height: 16px;
}
/*# sourceMappingURL=flow-drop-down.component.css.map */
